exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-6b1791a8]{max-height:200px}@media (max-width:575px){.btn[data-v-6b1791a8]{display:block;width:100%}}", ""]);

// exports
